module.exports = __webpack_public_path__ + "static/media/ReadMoreSVG.0aaec1d2.svg";